export default __webpack_public_path__ + "static/media/36I-102791_-15920_0.40af01f2.jpg";